module.exports = __webpack_public_path__ + "voice.1c62d6c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/chatsuite/voice.png
// module id = 2079
// module chunks = 0